import { updateStoredValues, validatePaymentsInfo } from '../helpers';
const updateUserTradeIn = (_ref, walletStorageService) => {
  let {
    types,
    initialState
  } = _ref;
  return function (payload, skipWalletStorageUpdate) {
    if (skipWalletStorageUpdate === void 0) {
      skipWalletStorageUpdate = false;
    }
    return async (dispatch, getState) => {
      const state = getState();
      const paymentsInfo = state?.payments || {};
      const myWalletConfigs = state?.payments?.myWallet?.configs || {};
      const isLoggedIn = state?.auth?.isLoggedIn || false;
      if (!skipWalletStorageUpdate) {
        validatePaymentsInfo(initialState, paymentsInfo, myWalletConfigs);
        const response = await updateStoredValues({
          paymentsInfo,
          payments: {
            tradeIn: {
              ...payload
            }
          },
          walletStorageService,
          isLoggedIn
        });
        dispatch({
          type: types.UPDATE_MY_WALLET,
          payload: {
            displayWalletErrorMessage: !response?.success || false
          }
        });
      }
      dispatch({
        type: types.UPDATE_USER_TRADE_IN,
        payload: {
          ...payload
        }
      });
    };
  };
};
export default updateUserTradeIn;